import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { OrgBankAccount, Organization } from 'src/typings';
import { OrgService } from '../org.service';
import { TaxationType } from '../org.dto';

@Component({
  selector: 'app-org-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  loading = false;
  dataSource: Organization[] = [];
  resultsLength = 0;
  pageSize = 10;

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

  searchForm: FormGroup = this.fb.group({
    name: new FormControl(''),
    edrpou: new FormControl(''),
    ipn: new FormControl(''),
    taxationType: new FormControl(null),
    isActive: new FormControl('all')
  });

  taxationTypes = Object.values(TaxationType);

  constructor(
    private orgService: OrgService,
    private fb: FormBuilder,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.searchByPage();
  }

  private resolveIsActiveFilter(): boolean | undefined {
    const value = this.searchForm.value.isActive;
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  }

  getActiveAccountsCount(org: Organization): number {
    return (org.bankAccounts || []).filter((account) => account.isActive).length;
  }

  getPrimaryAccount(org: Organization): OrgBankAccount | undefined {
    return (org.bankAccounts || []).find((account) => account.isPrimary);
  }

  async searchByPage(page = 0) {
    this.loading = true;
    try {
      const { name, edrpou, ipn, taxationType } = this.searchForm.value;
      const response = await firstValueFrom(
        this.orgService.search({
          name: name?.trim() || undefined,
          edrpou: edrpou?.trim() || undefined,
          ipn: ipn?.trim() || undefined,
          taxationType: taxationType || undefined,
          isActive: this.resolveIsActiveFilter(),
          limit: this.pageSize,
          offset: page * this.pageSize
        })
      );
      this.dataSource = response.data;
      this.resultsLength = response.length;
    } catch (err: any) {
      console.error(err);
      this.notificationService.warning(err?.error?.message || 'Ошибка загрузки организаций');
    } finally {
      this.loading = false;
    }
  }

  search() {
    this.paginator?.firstPage();
    this.searchByPage();
  }

  clearSearch() {
    this.searchForm.reset({
      name: '',
      edrpou: '',
      ipn: '',
      taxationType: null,
      isActive: 'all'
    });
    this.search();
  }

  async delete(org: Organization) {
    if (!confirm('Вы уверены что хотите удалить организацию?')) return;

    this.loading = true;
    try {
      await firstValueFrom(this.orgService.delete(org.id));
      this.notificationService.notice('Организация удалена');
      this.search();
    } catch (err: any) {
      console.error(err);
      this.notificationService.warning(err?.error?.message || 'Ошибка при удалении организации');
    } finally {
      this.loading = false;
    }
  }
}
